import React from "react";

// Official GRABARTE isotype (the triangular "A"). Vector from brandbook.
const Isotipo = ({ className = "", fill = "#edaa51", ...props }) => (
  <svg
    viewBox="0 0 47.57 41.09"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={fill}
      d="M28.76,8.81l-4.48,6.71L34.76,33.33H42.9l4.67,7.72L0,41.09,23.76,0ZM20.05,21.9,13.43,33.38H26.67Z"
    />
  </svg>
);

export default Isotipo;
